export default __webpack_public_path__ + "static/media/T240_RoHS.656e3c95.pdf";